import styled from "styled-components"
import { rgba } from "polished"
import grid from "~constants/grid"
import colors from "~constants/colors"
import { Form } from "~styled/form"

export const AuthLayout = styled.div`
  align-items: center;
  background: linear-gradient(
    160deg,
    ${colors.lightBlue2} 0%,
    ${colors.gray5} 60%,
    ${colors.white} 100%
  );
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
`

export const AuthContainer = styled.div`
  background-color: ${colors.white};
  border-radius: 20px;
  box-shadow: 0 24px 60px ${rgba(colors.blue3, 0.12)};
  display: flex;
  flex-direction: column;
  max-width: 440px;
  padding: 48px 44px 28px;
  width: 100%;

  > img:first-child {
    max-width: 132px;
    margin-bottom: 28px;
  }

  @media (max-width: ${grid.small}) {
    border-radius: 16px;
    padding: 36px 28px 24px;
  }
`

export const AuthHeading = styled.h1`
  color: ${colors.gray3};
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.3px;
  line-height: 1.2;
  margin: 0 0 6px;

  @media (max-width: ${grid.small}) {
    font-size: 23px;
  }
`

export const AuthSubtitle = styled.p`
  color: ${colors.gray6};
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
`

export const AuthForm = styled(Form)`
  margin-top: 28px;
  width: 100%;
`

export const AuthDescription = styled.p`
  color: ${colors.cerulean};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 21px;
  margin-bottom: 24px;
  max-width: 455px;
`

export const AuthError = styled.p`
  background-color: ${rgba(colors.red, 0.08)};
  border-radius: 8px;
  color: ${colors.red};
  font-size: 13px;
  margin: 0 0 4px;
  padding: 10px 14px;
  text-align: center;
`

export const AuthLink = styled.a`
  color: ${colors.cobalt};
  cursor: pointer;
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-top: 16px;
  text-align: center;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const AuthVersionBadge = styled.div`
  margin-top: 28px;
  padding-top: 4px;
  text-align: center;
  font-size: 11px;
  color: ${colors.gray6};
  user-select: text;
  letter-spacing: 0.3px;
`
